const isOnSimCreate = (obj) => {
  return typeof obj?.onSimCreate === "function";
};
export {
  isOnSimCreate
};
//# sourceMappingURL=OnSimCreate.js.map
